import React, { useState } from 'react';
import { FiTrendingUp, FiUsers, FiStar, FiVideo, FiSmile } from 'react-icons/fi';
import './FilterBar.css';

const FilterBar = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { id: 'trending', label: 'Tendencias', icon: <FiTrendingUp /> },
    { id: 'following', label: 'Seguidos', icon: <FiUsers /> },
    { id: 'foryou', label: 'Para Ti', icon: <FiStar /> },
    { id: 'videos', label: 'Videos', icon: <FiVideo /> },
    { id: 'memes', label: 'Memes', icon: <FiSmile /> }
  ];

  return (
    <div className="filter-bar">
      <div className="filter-bar-container">
        <div className="filter-buttons">
          {filters.map(filter => (
            <button
              key={filter.id}
              className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
              onClick={() => onFilterChange(filter.id)}
            >
              {filter.icon}
              <span>{filter.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
